<div>
    <table mat-table style="border-radius: 10px;"
    class="mat-elevation-z8 usr-table"
    multiTemplateDataRows
    [dataSource]="dataSource">
        <ng-container matColumnDef="expandArrow">
            <th mat-header-cell *matHeaderCellDef>
                &nbsp;
            </th>
            <td mat-cell *matCellDef="let element">
                <button mat-icon-button>
                    <mat-icon>
                        {{selectedRut !== null && selectedRut === element.rut ? 'keyboard_arrow_up': 'keyboard_arrow_down'}}
                    </mat-icon>
                </button>
            </td>
        </ng-container>
        <ng-container matColumnDef="rut">   
            <th mat-header-cell *matHeaderCellDef>
                Rut
            </th>
            <td mat-cell *matCellDef="let element">
                <h6>{{element.rut}}</h6>
            </td>
        </ng-container>

        <ng-container matColumnDef="firstName">   
            <th mat-header-cell *matHeaderCellDef>
                Nombre
            </th>
            <td mat-cell *matCellDef="let element">
                <h6>{{element.firstName+" "+element.lastName}}</h6>
            </td>
        </ng-container>

        <!--<ng-container matColumnDef="lastName">   
            <th mat-header-cell *matHeaderCellDef>
                Apellido
            </th>
            <td mat-cell *matCellDef="let element">
                <h6>{{element.lastName}}</h6>
            </td>
        </ng-container>-->

        <ng-container matColumnDef="email">   
            <th mat-header-cell *matHeaderCellDef>
                Email
            </th>
            <td mat-cell *matCellDef="let element">
                <h6>{{element.email}}</h6>
            </td>
        </ng-container>

        <ng-container matColumnDef="roles">   
            <th mat-header-cell *matHeaderCellDef>
                Role
            </th>
            <td mat-cell *matCellDef="let element" >
                <mat-chip style="font-size: 0.7rem;" color="primary" *ngFor="let rol of convertStringToList(element.roles)">{{ rol }}</mat-chip>
            </td>
        </ng-container>

        <ng-container matColumnDef="enabled">   
            <th mat-header-cell *matHeaderCellDef>
                Habilitado
            </th>
            <td mat-cell *matCellDef="let element" >
                <i-tabler *ngIf="element.enabled" style="color: green;" name="circle-check" class="theme-icon"></i-tabler>
                <i-tabler *ngIf="!element.enabled" style="color: red;" name="xbox-x" class="theme-icon"></i-tabler>
            </td>
        </ng-container>

        <ng-container matColumnDef="expandedDetail">
            <td mat-cell *matCellDef="let element"
            [attr.colspan]="displayedColumns.length">
                <div class="element-detail" 
                [@detailExpand]="selectedRut !== null && selectedRut == element.rut ? 'expanded':'collapsed'">
                    <div *ngIf="selectedRut === element.rut">
                        <app-user-roles-management [userId]="element.rut" (notify)="reciveNotify($event)"></app-user-roles-management>
                    </div>
                </div>
            </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr class="element-row" mat-row [cdkContextMenuTriggerFor]="menu"
        *matRowDef="let row; columns: displayedColumns"
        [class.expanded-row]="selectedRut !== null && selectedRut === row.rut"
        (click)="toggleExpandable(row.rut)">
        <ng-template #menu>
            <div cdkMenu class="context_menu mat-elevation-z8">
              <button
              *ngIf="!row.enabled"
                class="context-menu-item"
                cdkMenuItem
                mat-raised-button
                style="background-color: #3f51b5; color: white"
                (click)="habilitarUser(row.rut)"
              >
                Habilitar
              </button>
              <button
              *ngIf="row.enabled"
              class="context-menu-item"
              cdkMenuItem
              mat-raised-button
              style="background-color: red; color: white"
              (click)="dehabilitarUser(row.rut)"
            >
              Deshabilitar
            </button>
            </div>
          </ng-template>
        </tr>
        
        <tr mat-row *matRowDef="let row; columns:['expandedDetail']"
        class="detail-row">
        </tr>
    </table>
    <mat-paginator [pageSizeOptions]="[10, 20, 30]"></mat-paginator>
</div>


<mat-menu #menu>
    <ng-template matMenuContent let-aliasMenuItems="element">
        <button mat-menu-item>
            Roles
        </button>
    </ng-template>
</mat-menu>

